import {
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalNext,
} from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { WniMicroFrontendService } from 'wni-capability-microfrontend';
import useWniModal from '../../hooks/ModalNext/useWniModal';
import StatusComponent from '../SubmissionIntakeComponent/StatusComponent';
import metadata from './LossRunModal.metadata.json5';

function LossRunModal(props) {
    const modalApi = useWniModal();
    const {
        size,
        cancelBtnLabel,
        isOpen,
        onReject,
        title,
        useDependenciesData,
        jobID,
        sessionUUID,
        authHeader,
        useAuthenticationData,
        callbackMap,
    } = props;
    const {
        loadingMask: { setLoadingMask },
    } = useDependenciesData;
    const [file, updateFile] = useState(null);
    const [lossRunReviewUrl, updateLossRunReviewUrl] = useState();

    const getDocUploadToken = useCallback(async () => {
        try {
            const uploadTokenID =
                await GatewayDocumentService.generateUploadToken(authHeader);
            return uploadTokenID;
        } catch (e) {
            return modalApi
                .showAlert({
                    title: commonMessages.errorUploadTitle,
                    message: commonMessages.errorGenerateUploadToken,
                    status: 'error',
                    icon: 'gw-error-outline',
                    confirmButtonText: commonMessages.ok,
                })
                .catch(_.noop);
        }
    }, [authHeader, modalApi]);

    const uploadfile = (newfile) => {
        updateFile(newfile);
    };
    const handleImport = async () => {
        if (!file) {
            return false;
        }
        setLoadingMask(true);
        const documentMetaDataTemplate = {
            jobNumber: jobID,
            docUID: '001',
            documentType: 'Exc_Ext',
            status: 'approved',
            name: file.name,
            mimeType: file.type,
            sessionID: await getDocUploadToken(),
            sessionUUID: sessionUUID,
            page: 'vehicle',
        };

        const reviewUrl = await WniMicroFrontendService.getLossRunReviewUrl(file, documentMetaDataTemplate, authHeader);
        updateLossRunReviewUrl(reviewUrl);

        setLoadingMask(false);
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: 'left',
            showRequired: true,
        },
        uploadDoc: {
            singleUpload: true,
            uploadConfig: {
                uploadFiles: file,
                updateUploadFiles: updateFile,
                required: true
            }
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            uploadfile,
        },
        resolveComponentMap: {},
    };
    if (lossRunReviewUrl) {
        /**
         * Sample data structure
         * const callbackMapSample = {
         *   functionWithOnRejectCallback: {
         *     call: () => {
         *       console.log('functionWithOnRejectCallback');
         *     },
         *     needModalOnReject: true
         *   },
         *
         *   functionCallback: () => console.log("functionCallback")
         * }
         */
        const modalCallbackMap = {};
        _.each(callbackMap, (cb, key) => {
            if (_.isFunction(cb)) {
                modalCallbackMap[key] = cb;
            } else if (_.isFunction(_.get(cb, 'call'))) {
                if (_.get(cb, 'needModalOnReject') === true) {
                    const cbFunctionWithOnReject = (...params) => {
                        _.get(cb, 'call')(params);
                        onReject();
                    };
                    modalCallbackMap[key] = cbFunctionWithOnReject;
                } else {
                    modalCallbackMap[key] = _.get(cb, 'call');
                }
            }
        });

        return (
            <ModalNext isOpen={isOpen} className="full modalHeaderWithBorder">
                <ModalBody id="importLossRunMFE">
                    <StatusComponent
                        {...props}
                        acrodReviewUrl={lossRunReviewUrl}
                        submissionTokenId={lossRunReviewUrl.substring(
                            lossRunReviewUrl.indexOf('submissionID') + 13
                        )}
                        urlPrefix="/review"
                        requireManualStatusCheck={false}
                        authdata={useAuthenticationData}
                        callbackMap={modalCallbackMap}
                    />
                </ModalBody>
                <ModalFooter
                    contentLayout={{
                        component: 'flex',
                        componentProps: {
                            alignItems: 'middle',
                            justifyContent: 'between',
                        },
                    }}
                >
                    <Button
                        onClick={onReject}
                        type="outlined"
                        label={cancelBtnLabel}
                    />
                </ModalFooter>
            </ModalNext>
        );
    }

    return (
        <ModalNext isOpen={isOpen} className={`${size} modalHeaderWithBorder`}>
            <ModalHeader title={title} />
            <ModalBody id="importLossRun">
                <ViewModelForm
                    uiProps={metadata.componentContent}
                    overrideProps={overrideProps}
                    model={{}}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </ModalBody>
            <ModalFooter
                contentLayout={{
                    component: 'flex',
                    componentProps: {
                        alignItems: 'middle',
                        justifyContent: 'between',
                    },
                }}
            >
                <Button
                    onClick={onReject}
                    type="outlined"
                    label={cancelBtnLabel}
                />
                <Button
                    onClick={handleImport}
                    disabled={!file}
                    label="Import"
                />
            </ModalFooter>
        </ModalNext>
    );
}

LossRunModal.propTypes = {};
LossRunModal.defaultProps = {
    size: 'md',
};
export default LossRunModal;
